const { baseURL, default: Api } = require("./Api");

const BASE = `${baseURL('v2')}/ouvidoria/grupos`

export default {
  list: () => Api.get(BASE),
}
